import {
  getPayInfo,
  setAddressId,
  setPayInfo
} from '@/utils/Address.js'

const storageGoodsInfo = {
  payInfo: [],
  payType: '',
  cartInfo: {} // key 是 goods_sn , value 是 card_id
}

// 设置优惠券
const Set_welfareCard = (state, info) => {
  state.welfareCard = info
}

// 清空优惠券
const clearWelfareCard = state => {
  state.welfareCard = {}
}

// 设置订单号
const Set_orderId = (state, info) => {
  state.orderId = info
}
// 设置蛋糕门店
const Set_cake_shop = (state, info) => {
  state.cakeShop = info
}

const clean_Cake_shop = state => {
  state.cakeShop = ''
}

// 设置配送方式
const set_cake_delivery = (state, info) => {
  state.cakeDelivery = info
}

const set_cake_tiemline = (state, info) => {
  state.caketimeline = info
}

// 设置支付方式
/**
 * @typedef {Object} payWay
 * @property {String} payWay.type - 支付类型 saas | cansh
 * @property {String} payWay.id - 支付方式 id
 */

// const set_pay_way = (state, { type, id }) => {
//   if ( (!type && type !== 'saas' || type !== 'cansh') || !id) {
//     return
//   }
//   // 限制payway 超出的长度 1 删除第一个
//   const hasWay = state.payWay[type].find(item => item === id)
//   if (state.payWay[type].length >= 1 && hasWay) {
//     state.payWay[type].shift()
//   } else {
//     state.payWay[type].push(id)
//   }
// }

const mutations = {
  setAddressInfo: (state, addressInfo) => {
    state.addressInfo = addressInfo
  },
  SET_ADDRESSID: (state, addressId, addressInfo) => {
    if (addressId) {
      setAddressId(addressId)
      state.addressId = addressId
    }
  },
  GET_ADDRESSID: state => {
    return state.addressId
  },
  CLEAN_ADDRESSID: state => {
    state.addressId = ''
  },
  // 设置支付信息
  /**
   * @typedef {Object} payInfo
   * @property {Array} payInfo - 支付信息
   * @property {String} payType - 支付类型 cart 购物车结算 buyNow 立即购买结算
   */
  SET_PAYINFO: (state, info) => {
    const { payInfo, payType, cartInfo, movieInfo, goods_type } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payType = payType

      if (goods_type && goods_type === 'movie') {
        console.log('movieInfo', movieInfo)
          state.movieInfo = movieInfo
          state.goodsType = 'movie'
      } else {
        state.movieInfo = {}
        state.goodsType = ''
      }
      console.log('state', state)

      if (cartInfo) {
        state.cartInfo = cartInfo
        storageGoodsInfo.cartInfo = cartInfo
      }

      storageGoodsInfo.payInfo = payInfo
      storageGoodsInfo.payType = payType

      setPayInfo(storageGoodsInfo)
    }
  },
  Set_welfareCard,
  clearWelfareCard,
  Set_orderId,
  Set_cake_shop,
  clean_Cake_shop
  // set_pay_way
}

export default mutations
